/**
 * Created by mykurisu on 2017/9/15.
 */
import React from 'react'
import axios from 'axios'
import classnames from 'classnames'
import { browserHistory } from 'react-router'
import { ActionSheet, Toast } from 'react-weui'
import { isInSaasLiveroom, getSaasLiveroomId } from '@weike/services'
import { HTTPClient } from '@weike/toolkit'

import { Page } from '../../components'
import { WKInfiniteScroll, WKOwnDialog } from '../../components/wk'
import RecordRefund from './RecordRefund'
import { AppInteractiveLectureTip } from '../../components/appInteractiveLectureTip'
import { LihuaAPPTipComponent } from '../../components/lihuaAppTip'

import {
  renderMoney,
  TimeStream,
  isLZWKAPP,
  judgeAPPVersion,
  isLZWKAPPIpad,
  isLihuaApp,
  urlQueryGet,
  getAccessToken,
  getToken,
  setAccessToken
} from '../../utils'
import Config, { prodConfig } from '../../config'
import { toLecture, toClassroom } from '../../utils/connectApp'
import { toChatPage } from '../../services'
import { NoneItem } from '../../components/details'
import { isInteractiveChannel } from '../../utils/hardcode'

import '../../styles/record/RecordBuyListItem.css'

/**请求成功状态码 */
const HTTP_SUCCESS = '0000'
const http = new HTTPClient({ baseURL: Config.BASE_URL_ELSE }, HTTP_SUCCESS)
/**购买记录接口 */
const BUY_RECORD_API = `${Config.BASE_URL}/api/history/buy_record`
/**检查商品是否可开票 */
const FAPIAO_ISSUE_CHECK = `/v1/integration/wk_ticket/fapiao.special_init.check`
/**url是否带参invoice */
const urlHasInvoice = urlQueryGet(window.location.href, 'invoice') === '1'

class BoughtItem extends React.Component {
  renderProductType () {
    const { invoice } = this.props.item
    switch (invoice.product_type) {
      case 'pay_training_camp':
        return '训练营学费'
      case 'liveroom_vip':
        return 'VIP会员'
      case 'pay_lecture':
        return '课程学费'
      case 'gift_lecture':
        return '课程赠礼'
      case 'pay_channel':
      case 'pay_operate_channel':
        return '专栏学费'
      case 'gift_channel':
        return '专栏赠礼'
      case 'pay_schedule':
        return '打卡活动'
      case 'pay_channel_groupbuy':
        return '专栏拼团'
      case 'pay_member':
        return '荔枝微课会员'
      case 'pay_channel_member':
        return '会员免费听'
      case 'pgy_pay_channel':
        return '蒲公英专栏'
      case 'pay_channel_return':
        return '专栏返现'
      case 'pay_month_bag':
        const { typeName } = this.linkMonthBag()
        return typeName || ''
      default:
        return ''
    }
  }

  linkMonthBag () {
    const { product } = this.props.item
    switch (product.type) {
      case 'deposit_616':
        return {
          label: '跳转至会员产品页',
          link: `${prodConfig.MAIN_URL}/weike-regular-activity/member-card?scene=wk_ad__PersonalCenter`,
          typeName: '年度会员预售'
        }
      case 'pay_month_bag':
        return {
          label: `进入学习卡中心`,
          link: `/operation-business/membercard/activate?card_id=${product.id}&fr=bought`,
          typeName: '付费月卡'
        }
      case 'membership':
      case 'common_activity':
        return {
          label: '跳转至会员小程序',
          link: `${prodConfig.MAIN_URL}/weike-regular-activity/youke`,
          typeName: '年度会员'
        }
      default:
        return {}
    }
  }

  // 处理拼团状态
  handelGroupBuyStatus () {
    const { invoice } = this.props.item
    switch (invoice.activity_status) {
      case 'manual_close':
        return '停止拼团'
      case 'success':
        return '拼团成功'
      case 'failed':
        return '拼团失败'
      case 'process':
        return '待拼团'
      default:
        return ''
    }
  }

  // 拼团状态样式
  handleGroupClass () {
    const { invoice } = this.props.item
    switch (invoice.activity_status) {
      case 'manual_close':
        return 'group-buy-status group-buy-status-close'
      case 'success':
        return 'group-buy-status group-buy-status-success'
      case 'failed':
        return 'group-buy-status group-buy-status-failed'
      case 'process':
        return 'group-buy-status group-buy-status-process'
      default:
        return ''
    }
  }

  renderRefundStatus () {
    const { product_type, refund_status } = this.props.item.invoice
    if (
      [
        'pay_training_camp',
        'pay_lecture',
        'gift_lecture',
        'gift_channel',
        'pay_channel',
        'pay_operate_channel',
        'pay_schedule',
        'pay_channel_bag',
        'pay_channel_groupbuy',
        'liveroom_vip',
        'pay_month_bag'
      ].indexOf(product_type) > -1
    ) {
      if (
        refund_status === 'unrefund' ||
        refund_status === 'fail' ||
        refund_status === 'reject'
      ) {
        return true
      } else {
        if (refund_status === 'refunding') {
          return (
            <a
              className="record-buy-list-item_enterbtn-gray"
              style={{ fontSize: '12px' }}>
              等待退款
            </a>
          )
        } else if (refund_status === 'success') {
          return (
            <a
              className="record-buy-list-item_enterbtn-gray"
              style={{ fontSize: '12px' }}>
              已退款
            </a>
          )
        }
      }
    }
  }

  onClickBuyItem (item) {
    if (item.invoice.product_type === 'gift_lecture') {
      toLecture({ id: item.product.id, lectureMode: item.product.lecture_mode })
    } else {
      location.assign(`lizhiweike://channel?channel_id=${item.product.id}`)
    }
  }

  renderEnterBtn () {
    const { invoice, product } = this.props.item
    const shouldLinkToAPP =
      (isLZWKAPP() &&
        ((window.systemType === 'ios' && judgeAPPVersion(370)) ||
          (window.systemType === 'android' && judgeAPPVersion(262)))) ||
      isLZWKAPPIpad()
    const shouldLinkToClassroom =
      ((isLZWKAPP() && judgeAPPVersion(440)) || isLZWKAPPIpad()) &&
      product.lecture_mode === 'default'

    const navigateToChannel = (e) => {
      e.preventDefault()
      e.stopPropagation()
      // 梨花 app 显示弹窗提示
      if (isLihuaApp()) {
        this.props.showLihuaAppTip(product.id)
        return
      }
      // 是否是互动模式课程
      if (isInteractiveChannel(product.target_id) && isLZWKAPP()) {
        this.props.showAppInteractiveLectureTip()
        return
      }
      let url =
        Config.MAIN_URL + `/channel2/${product.target_id}${location.search}`
      if (shouldLinkToAPP) {
        url = `lizhiweike://channel?channel_id=${product.target_id}`
      }
      location.assign(url)
    }

    if (['gift_lecture', 'gift_channel'].indexOf(invoice.product_type) > -1) {
      if (isLZWKAPP() || isLZWKAPPIpad()) {
        if (
          (window.systemType === 'ios' && judgeAPPVersion(370)) ||
          (window.systemType === 'android' && judgeAPPVersion(262))
        ) {
          return (
            invoice.refund_status !== 'success' && (
              <a
                onClick={(e) => this.onClickBuyItem(this.props.item)}
                className="record-buy-list-item-button record-buy-list-item-button-enter">
                查看赠礼
              </a>
            )
          )
        } else {
          return (
            invoice.refund_status !== 'success' && (
              <a
                className="record-buy-list-item-button record-buy-list-item-button-enter"
                href={
                  invoice.product_type === 'gift_lecture' ? (
                    `/lecture/${product.id}`
                  ) : (
                    `/channel/${product.id}${location.search}`
                  )
                }>
                查看赠礼
              </a>
            )
          )
        }
      } else {
        return (
          invoice.refund_status !== 'success' && (
            <a
              className="record-buy-list-item-button record-buy-list-item-button-enter"
              href={
                invoice.product_type === 'gift_lecture' ? (
                  `/account/gift_card_detail/lecture/${product.target_id}`
                ) : (
                  `/account/gift_card_detail/channel/${product.target_id}`
                )
              }>
              查看赠礼
            </a>
          )
        )
      }
    } else if (invoice.product_type === 'liveroom_vip') {
      if (shouldLinkToAPP) {
        return (
          <a
            className="record-buy-list-item-button record-buy-list-item-button-enter"
            href={`lizhiweike://liveroom?liveroom_id=${product.target_id}`}>
            进入直播间
          </a>
        )
      } else {
        return (
          <a
            className="record-buy-list-item-button record-buy-list-item-button-enter"
            href={`/liveroom/${product.target_id}`}>
            进入直播间
          </a>
        )
      }
    } else if (
      invoice.product_type === 'pay_lecture' &&
      invoice.refund_status !== 'success'
    ) {
      if (isLZWKAPP() || isLZWKAPPIpad()) {
        if (shouldLinkToClassroom) {
          return (
            <a
              className="record-buy-list-item-button record-buy-list-item-button-enter"
              onClick={(e) => toClassroom(product.target_id)}>
              进入听课
            </a>
          )
        } else {
          return (
            <a
              className="record-buy-list-item-button record-buy-list-item-button-enter"
              onClick={(e) =>
                toLecture({
                  id: product.target_id,
                  lectureMode: product.lecture_mode
                })}>
              进入听课
            </a>
          )
        }
      } else {
        return (
          <a
            className="record-buy-list-item-button record-buy-list-item-button-enter"
            href={
              product.lecture_mode === 'default' ? (
                `/classroom/${product.target_id}`
              ) : (
                `/lecture/${product.target_id}`
              )
            }>
            进入听课
          </a>
        )
      }
    } else if (
      invoice.product_type === 'pay_channel' ||
      invoice.product_type === 'pay_channel_member' ||
      invoice.product_type === 'pay_channel_return'
    ) {
      return (
        <div>
          {urlHasInvoice && (typeof invoice.can_invoice === 'boolean') && (
            <button
              className={
                classnames(
                  'record-buy-list-item-button',
                  invoice.can_invoice && 'record-buy-list-item-button-enter'
                )
              }
              onClick={() => {
                window.location.assign(
                  Config.MAIN_URL + `/activity2/invoice/${product.id}`
                )
              }}
            >
              {invoice.can_invoice ? '申请开票': '已开票'}
            </button>
          )}
          <button
            className="record-buy-list-item-button record-buy-list-item-button-enter"
            onClick={navigateToChannel}>
            进入专栏
          </button>
        </div>
      )
    } else if (invoice.product_type === 'pay_schedule') {
      if (shouldLinkToAPP) {
        return null
      } else {
        let link = `/schedule/${product.target_id}`
        return (
          <a
            className="record-buy-list-item-button record-buy-list-item-button-enter"
            href={link}>
            进入打卡
          </a>
        )
      }
    } else if (invoice.product_type === 'pay_channel_groupbuy') {
      if (shouldLinkToAPP) {
        return null
      } else {
        let link = `/channel/group_buy?id=${product.target_id}`
        return (
          <a
            className="record-buy-list-item-button record-buy-list-item-button-enter"
            href={link}>
            拼团情况
          </a>
        )
      }
    } else if (invoice.product_type === 'pay_training_camp') {
      // 训练营
      if (isLZWKAPP() || isLZWKAPPIpad()) {
        return '请前往荔枝微课公众号查看详情'
      } else {
        let link = `/traincamp/${product.target_id}`
        return (
          <a
            className="record-buy-list-item-button record-buy-list-item-button-enter"
            href={link}>
            进入训练营
          </a>
        )
      }
    } else if (invoice.product_type === 'pay_month_bag') {
      // 月卡特例 wtf
      const { link, label } = this.linkMonthBag()
      return (
        <a
          className="record-buy-list-item-button record-buy-list-item-button-enter"
          href={link || ''}>
          {label || ''}
        </a>
      )
    } else {
      return ''
    }
  }

  navigateToDetail (e) {
    e.preventDefault()
    e.stopPropagation()
    const { product } = this.props.item
    if (isLihuaApp()) {
      this.props.showLihuaAppTip(product.id)
      return
    }
    if (isInteractiveChannel(product.id) && isLZWKAPP()) {
      this.props.showAppInteractiveLectureTip()
      return
    }
    const link = this.renderLink()
    location.assign(link)
  }

  renderLink () {
    const { product, invoice } = this.props.item
    const shouldLinkToAPP =
      (isLZWKAPP() &&
        ((window.systemType === 'ios' && judgeAPPVersion(370)) ||
          (window.systemType === 'android' && judgeAPPVersion(262)))) ||
      isLZWKAPPIpad()

    if (product.type === 'lecture') {
      if (invoice.product_type === 'gift_lecture') {
        if (isLZWKAPP() || isLZWKAPPIpad()) {
          if (shouldLinkToAPP) {
            return toLecture({
              id: product.id,
              lectureMode: product.lecture_mode,
              isReturn: true
            })
          } else {
            return `/lecture/${product.id}`
          }
        } else {
          return `/account/gift_card_detail/lecture/${product.target_id}`
        }
      } else {
        if (shouldLinkToAPP) {
          return toLecture({
            id: product.target_id,
            lectureMode: product.lecture_mode,
            isReturn: true
          })
        } else {
          return `/lecture/${product.target_id}`
        }
      }
    } else if (product.type === 'channel') {
      if (invoice.product_type === 'pay_channel_groupbuy') {
        if (isLZWKAPP() || isLZWKAPPIpad()) {
          if (shouldLinkToAPP) {
            return `lizhiweike://channel?channel_id=${product.id}`
          } else {
            return `/channel/${product.id}${location.search}`
          }
        } else {
          return `/channel/${product.id}${location.search}`
        }
      }
      if (invoice.product_type === 'gift_channel') {
        if (isLZWKAPP() || isLZWKAPPIpad()) {
          if (shouldLinkToAPP) {
            return `lizhiweike://channel?channel_id=${product.id}`
          } else {
            return `/channel/${product.id}${location.search}`
          }
        } else {
          return `/account/gift_card_detail/channel/${product.target_id}`
        }
      } else {
        if (shouldLinkToAPP) {
          return `lizhiweike://channel?channel_id=${product.target_id}`
        } else {
          let link = `/channel/${product.target_id}${location.search}`
          return link
        }
      }
    } else if (product.type === 'liveroom') {
      if (shouldLinkToAPP) {
        return `lizhiweike://liveroom?liveroom_id=${product.target_id}`
      } else {
        return `/liveroom/${product.target_id}`
      }
    } else if (product.type === 'pay_schedule') {
      if (shouldLinkToAPP) {
        return ''
      } else {
        return `/schedule/${product.target_id}`
      }
    } else if (invoice.product_type === 'pay_member') {
      if (shouldLinkToAPP) {
        return null
      } else {
        return `/supervip`
      }
    } else if (invoice.product_type === 'pay_training_camp') {
      // 训练营
      if (isLZWKAPP() || isLZWKAPPIpad()) {
        return
      } else {
        return `/traincamp/${product.target_id}`
      }
    } else if (invoice.product_type === 'pay_month_bag') {
      const { link } = this.linkMonthBag()
      return link || ''
    } else {
      return ''
    }
  }

  // 点击售后
  async handleT () {
    this.props.handleSheetToggle()
    this.props.setselectedItem({
      ...this.props.item
    })
  }

  toEvaluation (id) {
    if (browserHistory.getCurrentLocation().pathname === '/specials/mywk') {
      location.assign(`/account/bought/evaluation/${id}?_fromPath=mywk`)
    } else {
      location.assign(`/account/bought/evaluation/${id}`)
    }
  }

  render () {
    const { isWhiteAccount, product, invoice } = this.props.item
    if (product.type === 'channel_bag') {
      return (
        <div
          className="record-page-container"
          onClick={() => {
            this.props.handleShowBag(invoice.id)
            this.props.setselectedItem(this.props.item)
          }}>
          <div className="record-page-list-header">
            <span>订单类型：专栏打包</span>
            <span>购于：{TimeStream(invoice.create_timestamp, 'YMD')}</span>
          </div>
          <div className="weui-flex weui-padding record-buy-list-item">
            <div className="weui-flex__item flex_3">
              <div
                className="record-buy-list-item_img background-image"
                style={{ backgroundImage: `url(${product.cover})` }}
              />
            </div>
            <div className="weui-flex__item flex_9 padding-left record-buy-list-item-content">
              <p className="record-buy-list-item_title">{product.name}</p>
              {/* <p className="record-buy-list-item_text-hasmargin">
                                订单类型: 专栏打包
                            </p>
                            <p className="record-buy-list-item_text">
                                购于:{TimeStream(invoice.create_timestamp, 'YMD')}
                                <span className="record-buy-list-item_price">¥{renderMoney(invoice.fee)}</span>
                            </p> */}
              <p className="record-buy-list-item_text">
                {/* 购于：{TimeStream(invoice.create_timestamp, 'YMD')} */}
                {invoice.product_type !== 'pay_channel_member' && (
                  <span className="record-buy-list-item_price">
                    ¥{renderMoney(invoice.fee)}
                  </span>
                )}
              </p>
            </div>
          </div>
          <div className="weui-padding record-buy-list-item_topborder">
            <div className="record-buy-list-after-sale" />
            <div className="record-buy-list-menu-btn">
              {this.renderRefundStatus()}
            </div>
          </div>
          {this.props.cancelRefundShow && (
            <WKOwnDialog
              type="ios"
              title="温馨提示"
              buttons={[
                {
                  type: 'default',
                  label: '取消',
                  onClick: this.props.handleCancelRefundPanelHide
                },
                {
                  type: 'primary',
                  label: '确定',
                  onClick: () =>
                    this.props.handleCancelRefundAction(this.props.item)
                }
              ]}
              show={true}>
              你的退款申请已提交给讲师，确定要撤销退款吗？
            </WKOwnDialog>
          )}

          {this.props.refundShow && (
            <RecordRefund
              isWhiteAccount={isWhiteAccount}
              RefundShow={true}
              selectInvoice={invoice.id}
              handleRefundPanelHide={() => this.props.handleRefundPanelHide()}
              handleRefundSuccess={(selectedId) =>
                this.props.handleRefundSuccess(selectedId)}
            />
          )}
        </div>
      )
    }
    return (
      <div className="record-page-container">
        <div className="record-page-list-header">
          <span>订单类型：{this.renderProductType()}</span>
          <span>购于：{TimeStream(invoice.create_timestamp, 'YMD')}</span>
        </div>
        <a href={this.renderLink()} onClick={this.navigateToDetail.bind(this)}>
          <div
            className="weui-flex weui-padding record-buy-list-item"
            onClick={(e) => {
              if (
                invoice.product_type === 'pay_training_camp' &&
                (isLZWKAPP() || isLZWKAPPIpad())
              ) {
                e.stopPropagation()
                alert('请前往荔枝微课公众号查看详情')
                return
              }
            }}>
            <div className="weui-flex__item flex_3">
              <div
                className="record-buy-list-item_img background-image"
                style={{ backgroundImage: `url(${product.cover})` }}
              />
            </div>
            <div className="weui-flex__item flex_9 padding-left record-buy-list-item-content">
              <p
                className={
                  invoice.activity_status ? (
                    'record-buy-list-item_title fix-group'
                  ) : (
                    'record-buy-list-item_title'
                  )
                }>
                {product.name}
              </p>
              {/* <p className="record-buy-list-item_text-hasmargin">
                                订单类型：{this.renderProductType()}
                            </p> */}
              <p className="record-buy-list-item_text">
                {/* 购于：{TimeStream(invoice.create_timestamp, 'YMD')} */}
                {invoice.product_type !== 'pay_channel_member' && (
                  <span className="record-buy-list-item_price">
                    ¥{renderMoney(invoice.fee)}
                  </span>
                )}
                {/* 专栏返现特例 */}
                {product.type === 'pay_channel_return' && (
                  <span style={{ float: 'right' }}>
                    已返现：¥{product.return_money / 100}
                  </span>
                )}
              </p>
              {invoice.activity_status && (
                <span className={this.handleGroupClass()}>
                  {this.handelGroupBuyStatus()}
                </span>
              )}
            </div>
          </div>
        </a>
        <div className="weui-padding record-buy-list-item_topborder">
          <div className="record-buy-list-after-sale" />
          <div className="record-buy-list-menu-btn">
            {this.renderRefundStatus()}

            {product.can_evaluate &&
            product.has_evaluate &&
            invoice.refund_status !== 'success' && (
              <a
                className="record-buy-list-item-button"
                onClick={(e) => this.toEvaluation(invoice.id)}>
                已评价
              </a>
            )}
            {product.can_evaluate &&
            !product.has_evaluate &&
            invoice.refund_status !== 'success' && (
              <a
                className="record-buy-list-item-button"
                onClick={(e) => this.toEvaluation(invoice.id)}>
                评价
              </a>
            )}
            {invoice.refund_status !== 'success' &&
            invoice.product_type !== 'pay_month_bag' && (
              <button
                className="record-buy-list-item-button"
                onClick={this.handleT.bind(this)}>
                售后
              </button>
            )}

            {this.renderEnterBtn()}
          </div>
        </div>

        {this.props.cancelRefundShow && (
          <WKOwnDialog
            type="ios"
            title="温馨提示"
            buttons={[
              {
                type: 'default',
                label: '取消',
                onClick: this.props.handleCancelRefundPanelHide
              },
              {
                type: 'primary',
                label: '确定',
                onClick: () =>
                  this.props.handleCancelRefundAction(this.props.item)
              }
            ]}
            show={true}>
            你的退款申请已提交给讲师，确定要撤销退款吗？
          </WKOwnDialog>
        )}

        {this.props.refundShow && (
          <RecordRefund
            item={invoice.product_type}
            isWhiteAccount={isWhiteAccount}
            RefundShow={true}
            selectInvoice={invoice.id}
            handleRefundPanelHide={() => this.props.handleRefundPanelHide()}
            handleRefundSuccess={(selectedId) =>
              this.props.handleRefundSuccess(selectedId)}
          />
        )}
      </div>
    )
  }
}

class BoughtList extends React.Component {
  constructor () {
    super()
    this.state = {
      list: null,
      has_more: null,
      next_offset: null,
      loading: false,
      ActionSheetShow: false,
      refundShow: false,
      cancelRefundShow: false,
      ifShowToast: false,
      renderItemMenus: [],
      whitelist: [],
      toastTimer: null,
      actions: [
        {
          label: '取消',
          onClick: this.handleSheetToggle.bind(this)
        }
      ],
      selectedItem: '',
      ChannelBagSheetShow: false,
      ChannelBagactions: [
        {
          label: '取消',
          onClick: () => this.handleClearBag()
        }
      ],
      channel_bag_id: 0,
      channel_bag_list: [],
      isShowWarnToast: false,
      warnToastText: '',
      isShowAppInteractiveLectureTip: false // 是否显示 app 互动课程的提示
    }
    this.handleQrcodeShow = this.handleQrcodeShow.bind(this)
    this.handleEnterChat = this.handleEnterChat.bind(this)
    this.handleRefundPanelShow = this.handleRefundPanelShow.bind(this)
    this.handleCancelRefundSuccess = this.handleCancelRefundSuccess.bind(this)
    this.handleCancelRefundPanelShow = this.handleCancelRefundPanelShow.bind(
      this
    )
    this.showAppInteractiveLectureTip = this.showAppInteractiveLectureTip.bind(
      this
    )
  }

  async componentDidMount () {
    document.body.scrollTop = 0
    document.body.addEventListener('touchstart', function () {}) //尝试解决active失效
    try {
      await this.fetchWhitelist()
      const buy_record_list = await this.getButRecord()
      await this.checkFaPiaoIssue(buy_record_list)
    } catch (err) {
      console.log(err)
    }
  }

  getButRecord () {
    return new Promise((resolve, reject) => {
      const product = urlQueryGet(window.location.href, 'product')
      axios
        .get(BUY_RECORD_API, {
          params: {
            offset: this.state.next_offset,
            product: product === 'pay_channel' ? product : undefined
          }
        })
        .then((res) => {
          if (res.data.code === 0) {
            const list = (this.state.list || []).concat(res.data.data.records)
            if (this.state.whitelist && this.state.whitelist.length) {
              list.forEach(
                (item) =>
                  (item.isWhiteAccount =
                    this.state.whitelist.indexOf(item.invoice.receiver_id) !==
                    -1
                      ? true
                      : false)
              )
            }
            this.setState({
              list,
              has_more: res.data.data.has_more,
              next_offset: res.data.data.next_offset
            })
            resolve(list)
          } else {
            resolve([])
          }
        })
        .catch((err) => {
          reject(err)
        })
    })
  }

  async checkFaPiaoIssue (invoice_list) {
    const order_ids = []
    invoice_list.map((item) => {
      if (item.invoice.product_type === 'pay_channel') {
        order_ids.push(item.invoice.id)
      }
    })
    if (order_ids.length === 0) return
    if (!urlHasInvoice) return
    // 请求接口判断能否开票
    try {
      const { data: { order_dict } } = await http.post(
        FAPIAO_ISSUE_CHECK,
        {
          source: 'weike',
          order_ids,
          token: getAccessToken()
        },
        {
          timeout: 1000
        }
      )
      const ids = Object.keys(order_dict)
      invoice_list.map((item) => {
        const index =
          ids.length === 0
            ? -1
            : ids.findIndex((id) => Number(id) === item.invoice.id)
        if (index > -1) {
          item.invoice.can_invoice = order_dict[item.invoice.id]
        }
      })
      this.setState({ list: invoice_list })
    } catch (err) {
      console.log(err)
    }
  }

  handleLoadMore () {
    this.setState(
      {
        loading: true
      },
      async () => {
        try {
          const buy_record_list = await this.getButRecord()
          await this.checkFaPiaoIssue(buy_record_list)
        } catch (err) {
          console.log(err)
        }
        this.setState({
          loading: false
        })
      }
    )
  }
  async getAccessTokenApi () {
    try {
      const { data: { code, access_token } } = await axios
        .create({
          baseURL: Config.AUTH_URL
        })
        .get(
          `/oauth2/access_token?client_id=${Config.CLIENT_ID}&grant_type=cookie&id_token=${getToken()}`,
          {
            withCredentials: true
          }
        )
      if (code === 0) {
        setAccessToken(access_token)
      }
    } catch (error) {
      console.log(error)
    }
  }

  // 获取白名单列表
  async fetchWhitelist () {
    let access_token = getAccessToken()
    if (!access_token) {
      await this.getAccessTokenApi()
      access_token = getAccessToken()
    }
    return axios
      .get(`${Config.gateway_root_url}/config/get_whitelist_detail`, {
        params: {
          server_name: 'account_model',
          key: 'close_refund_entry_in_liveroom',
          version: '1.0',
          token: access_token
        }
      })
      .then((res) => {
        if (res.data.data && res.data.data.config_value) {
          const white_list =
            res.data.data.config_value.account_id.white_list || []
          this.setState({ whitelist: white_list })
          localStorage.setItem('set_white_list', white_list)
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }

  handleSheetToggle () {
    this.setState({
      ActionSheetShow: !this.state.ActionSheetShow
    })
  }

  handleEnterChat () {
    let account_id = this.state.selectedItem.invoice.receiver_id
    toChatPage(account_id)
  }

  setselectedItem (item) {
    this.setState({ selectedItem: item })
  }

  handleQrcodeShow () {
    this.handleSheetToggle()
    window.location.href = '/activity/servicepage/'
  }

  handleRefundPanelShow () {
    this.setState({
      refundShow: true,
      ActionSheetShow: !this.state.ActionSheetShow
    })
  }

  handleCancelRefundPanelShow () {
    this.setState({
      cancelRefundShow: true,
      ActionSheetShow: !this.state.ActionSheetShow
    })
  }

  handleCancelRefundPanelHide () {
    this.setState({
      cancelRefundShow: false
    })
  }

  handleRefundPanelHide () {
    this.setState({
      refundShow: false
    })
  }

  handleRefundSuccess (selectedId) {
    let index = this.state.list.findIndex((value) => {
      return value.invoice.id === selectedId
    })
    let list = [].concat(this.state.list)
    list[index].invoice.can_apply_refund = false
    list[index].invoice.refund_status = 'refunding'
    this.setState({
      list: list
    })
  }

  handleShowBag (id) {
    this.setState(
      {
        channel_bag_id: id
      },
      () => {
        this.setState({
          ChannelBagSheetShow: true
        })
      }
    )
  }

  handleClearBag () {
    this.setState({
      ChannelBagSheetShow: false,
      channel_bag_list: []
    })
  }

  renderMenus () {
    const { selectedItem } = this.state
    if (!selectedItem) return []

    const menu = [
      {
        label: '联系讲师',
        onClick: this.handleEnterChat
      },
      {
        label: '联系客服',
        onClick: this.handleQrcodeShow
      }
    ]
    /**是否是微课超级会员 */
    const isPayMember = selectedItem.invoice.product_type === 'pay_member'
    /**能否退款 */
    const canApplyRefund = selectedItem.invoice.can_apply_refund
    /**是否正在退款中 */
    const isRefunding = selectedItem.invoice.refund_status === 'refunding'

    if (isPayMember) {
      // 超级会员只有联系客服入口
      menu.shift()
    } else {
      if (canApplyRefund) {
        menu.push({
          label: '申请退款',
          onClick: this.handleRefundPanelShow.bind(this)
        })
      }

      if (isRefunding) {
        menu.push({
          label: '撤销退款',
          onClick: this.handleCancelRefundPanelShow.bind(this)
        })
      }
    }
    return menu
  }

  handleChannelBagListSkip (item) {
    const shouldLinkToAPP =
      (isLZWKAPP() &&
        ((window.systemType === 'ios' && judgeAPPVersion(370)) ||
          (window.systemType === 'android' && judgeAPPVersion(262)))) ||
      isLZWKAPPIpad()
    if (shouldLinkToAPP) {
      return location.assign(`lizhiweike://channel?channel_id=${item.id}`)
    } else {
      return location.assign(
        Config.MAIN_URL + `/channel2/${item.id}${location.search}`
      )
    }
  }

  renderChannelBagList () {
    if (this.state.ChannelBagSheetShow) {
      if (this.state.channel_bag_list.length === 0) {
        axios
          .get(`/api/history/${this.state.channel_bag_id}/sub_invoice`)
          .then((res) => {
            if (res.data.code === 0) {
              this.setState({
                channel_bag_list: res.data.data.records
              })
            }
          })
      }

      return (
        <div className="record-page-channel-bag">
          {this.state.channel_bag_list &&
            this.state.channel_bag_list.length > 0 &&
            this.state.channel_bag_list.map((item) => {
              return (
                <div
                  onClick={() => this.handleChannelBagListSkip(item.product)}
                  className="record-page-channel-bag-item"
                  key={'bag_list_' + item.invoice.id}>
                  <div
                    className="item__img"
                    style={{ backgroundImage: `url(${item.product.cover})` }}
                  />
                  <div className="item__title">{item.product.name}</div>
                </div>
              )
            })}
          {this.state.channel_bag_list.length !== 0 &&
          false && (
            <div
              className="channel__bag-refund"
              onClick={() =>
                this.setState({
                  refundShow: true
                })}>
              申请退款
            </div>
          )}
        </div>
      )
    }
  }

  handleCancelRefundSuccess (item) {
    let index = this.state.list.findIndex((value) => {
      return value.invoice.id === item.invoice.id
    })
    let list = [].concat(this.state.list)
    list[index].invoice.can_apply_refund = true
    list[index].invoice.refund_status = 'unrefund'
    this.setState({
      list: list
    })
  }

  handleCancelRefundAction (item) {
    axios.post(`/api/invoice/${item.invoice.id}/refund/revoke`).then((res) => {
      if (res.data.code === 0) {
        this.handleCancelRefundSuccess(item)
        this.setState({
          cancelRefundShow: false,
          ifShowToast: true
        })
        setTimeout(() => {
          this.setState({ ifShowToast: false })
        }, 2000)
      } else {
        this.setState({
          cancelRefundShow: false,
          isShowWarnToast: true,
          warnToastText: res.data.msg
        })
        setTimeout(() => {
          this.setState({ warnToastText: '', isShowWarnToast: false })
        }, 2000)
      }
    })
  }

  renderContent () {
    if (this.state.list) {
      if (this.state.list.length > 0) {
        return (
          <div>
            {this.state.list.map((item) => (
              <BoughtItem
                ifShowToast={this.state.ifShowToast}
                handleCancelRefundAction={(item) =>
                  this.handleCancelRefundAction(item)}
                setselectedItem={(item) => this.setselectedItem(item)}
                key={item.invoice.id}
                item={item}
                handleSheetToggle={() => this.handleSheetToggle()}
                refundShow={
                  this.state.refundShow &&
                  item.invoice.id === this.state.selectedItem.invoice.id
                }
                cancelRefundShow={
                  this.state.cancelRefundShow &&
                  item.invoice.id === this.state.selectedItem.invoice.id
                }
                handleRefundPanelHide={() => this.handleRefundPanelHide()}
                handleCancelRefundPanelHide={() =>
                  this.handleCancelRefundPanelHide()}
                handleRefundSuccess={(selectedId) =>
                  this.handleRefundSuccess(selectedId)}
                handleShowBag={(id) => this.handleShowBag(id)}
                showAppInteractiveLectureTip={this.showAppInteractiveLectureTip}
                showLihuaAppTip={this.showLihuaAppTip.bind(this)}
              />
            ))}
            <WKInfiniteScroll
              onTouchBottom={() => this.handleLoadMore()} // 到达底部执行的方法
              isStop={this.state.loading} // 暂停执行onTouchBottom，一般是正在请求接口时触发
              distance={300} // 距离底部多少px触发
              isKill={!this.state.has_more || this.props.tab !== 0} // 不再监听滚动，一般是传has_more
            />
          </div>
        )
      } else {
        return (
          <div className="record-page-list_no">
            <NoneItem
              img="https://static-1253442168.image.myqcloud.com/picture/5915685_3c997315c2944de062355158910c7f1c.jpg"
              text="还没开始学习？"
              btnMethod={(e) => {
                if (isInSaasLiveroom()) {
                  location.assign(
                    `${window.location.origin}/liveroom2/${getSaasLiveroomId()}`
                  )
                  return
                }
                const isApp =
                  isLZWKAPP() &&
                  ((window.systemType === 'ios' && judgeAPPVersion(360)) ||
                    (window.systemType === 'android' && judgeAPPVersion(260)))
                isApp || isLZWKAPPIpad()
                  ? location.assign(
                      `${window.location
                        .origin}/coupons-bag/newcomer/usecoupon?couponid=44&inviter_id=46974047`
                    )
                  : location.assign(
                      `${window.location
                        .origin}/activity/seckill?inviter_id=44814310`
                    )
              }}
              btnText={isInSaasLiveroom() ? '回首页看看' : '去领红包'}
            />
          </div>
        )
      }
    } else {
      return null
    }
  }

  showAppInteractiveLectureTip () {
    this.appInteractiveLectureTip.show()
  }

  showLihuaAppTip (channelId) {
    this.lihuaAppTipRef.open(channelId)
  }

  render () {
    return (
      <Page>
        <div className={`record-page-list-outline`}>
          <Toast icon="success-no-circle" show={this.state.ifShowToast}>
            已撤销退款
          </Toast>
          <Toast icon="warn" show={this.state.isShowWarnToast}>
            {this.state.warnToastText}
          </Toast>
          {this.renderContent()}
          <div style={{ position: 'relative', zIndex: '100' }}>
            <ActionSheet
              menus={this.renderMenus()}
              actions={this.state.actions}
              show={this.state.ActionSheetShow}
              type="ios"
              onTouchStart={() => {}}
              onRequestClose={() => this.setState({ ActionSheetShow: false })}
            />
          </div>
          <div style={{ position: 'relative', zIndex: '100' }}>
            <ActionSheet
              menus={[{ label: this.renderChannelBagList() }]}
              actions={this.state.ChannelBagactions}
              show={this.state.ChannelBagSheetShow}
              type="ios"
              onTouchStart={() => {}}
              onRequestClose={() => this.handleClearBag()}
            />
          </div>
          <AppInteractiveLectureTip
            ref={(ref) => (this.appInteractiveLectureTip = ref)}
          />
          <LihuaAPPTipComponent ref={(ref) => (this.lihuaAppTipRef = ref)} />
        </div>
      </Page>
    )
  }
}

export default BoughtList



// WEBPACK FOOTER //
// ./src/pages/BoughtPage/BoughtList.js